(() => {
  const moneyFormatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD',
  });

  function getPreferredCartUI() {
    if (window.innerWidth < 750) {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function formatMoney(cents, currency) {
    const value = (Number(cents) || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(value);
    } catch (error) {
      return moneyFormatter.format(value);
    }
  }

  function getSections(cartUI) {
    if (!cartUI || typeof cartUI.getSectionsToRender !== 'function') return [];

    return cartUI.getSectionsToRender().map((section) => section.id);
  }

  function getCheckoutUrl() {
    const rootUrl = window.routes?.root_url || window.Shopify?.routes?.root || '/';

    return `${rootUrl.replace(/\/?$/, '/')}checkout`;
  }

  function getQuantity(form) {
    const quantity = Number.parseInt(new FormData(form).get('quantity'), 10);
    return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  function getSellingPlanId(form) {
    const productContext =
      form.closest('product-info, .product__info-container, .main-product') ||
      document.querySelector('product-info, .product__info-container, .main-product') ||
      document;
    const ritualSelector = productContext.querySelector('ritual-subscription-selector');
    const ritualPurchaseInput = ritualSelector?.querySelector('[data-ritual-purchase-option]:checked');

    if (ritualPurchaseInput?.value === 'one-time') return '';

    const subscriptionBlock = productContext.querySelector('.shopify_subscriptions_app_block');

    if (subscriptionBlock) {
      const checkedPurchaseInput = subscriptionBlock.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      const checkedPurchaseOption = checkedPurchaseInput?.closest('label, li, .shopify_subscriptions_app_block_label, .shopify_subscriptions_purchase_option_wrapper');
      const checkedPurchaseValue = `${checkedPurchaseInput?.value || ''}`.toLowerCase();
      const checkedPurchaseText = `${checkedPurchaseOption?.textContent || ''}`.toLowerCase();
      const scopedSellingPlan = checkedPurchaseOption?.querySelector('[name="selling_plan"]');
      const isOneTimeSelected =
        checkedPurchaseInput?.closest('.shopify_subscriptions_app_block_one_time_purchase_option') ||
        checkedPurchaseOption?.classList.contains('shopify_subscriptions_app_block_one_time_purchase_option') ||
        checkedPurchaseValue.includes('one_time') ||
        checkedPurchaseValue.includes('one-time') ||
        checkedPurchaseValue.includes('onetime') ||
        checkedPurchaseText.includes('one-time') ||
        checkedPurchaseText.includes('one time') ||
        checkedPurchaseText.includes('one‑time');

      if (isOneTimeSelected) return '';
      if (checkedPurchaseInput?.name === 'selling_plan') return checkedPurchaseInput.value ? `${checkedPurchaseInput.value}` : '';
      if (scopedSellingPlan?.value) return `${scopedSellingPlan.value}`;

      const checkedPlanInput = subscriptionBlock.querySelector('[name="selling_plan"]:checked');
      if (checkedPlanInput) return checkedPlanInput.value ? `${checkedPlanInput.value}` : '';
    }


    const checkedInput = productContext.querySelector('[name="selling_plan"]:checked');
    if (checkedInput) return checkedInput.value ? `${checkedInput.value}` : '';

    const formDataValue = new FormData(form).get('selling_plan');
    if (formDataValue) return `${formDataValue}`;

    const selectedInput = productContext.querySelector('[name="selling_plan"]:not(:disabled)');
    if (selectedInput?.tagName !== 'SELECT' && selectedInput?.type !== 'hidden') return '';
    return selectedInput?.value ? `${selectedInput.value}` : '';
  }

  class BundleSelectionModal {
    constructor(root) {
      this.root = root;
      this.dialog = root.querySelector('.product-bundle-selection__dialog');
      this.itemsRoot = root.querySelector('[data-bundle-selection-items]');
      this.form = root.querySelector('[data-bundle-selection-form]');
      this.total = root.querySelector('[data-bundle-selection-total]');
      this.intro = root.querySelector('[data-bundle-selection-intro]');
      this.shippingMessage = root.querySelector('[data-bundle-selection-shipping]');
      this.selectFullButton = root.querySelector('[data-bundle-selection-all]');
      this.submitButton = root.querySelector('.product-bundle-selection__submit');
      this.data = this.readData();
      this.variant = null;
      this.productForm = null;
      this.quantity = 1;
      this.sellingPlanId = '';
      this.isSubmitting = false;

      this.bindEvents();
    }

    readData() {
      const dataScript = this.root.querySelector('[data-bundle-selection-data]');
      if (!dataScript) return { variants: {} };

      try {
        return JSON.parse(dataScript.textContent);
      } catch (error) {
        console.error(error);
        return { variants: {} };
      }
    }

    bindEvents() {
      this.root.querySelectorAll('[data-bundle-selection-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      this.root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      this.form.addEventListener('change', (event) => {
        if (!event.target.matches('[data-bundle-selection-checkbox]')) return;
        event.target.closest('.product-bundle-selection__item')?.classList.toggle('is-checked', event.target.checked);
        this.updateState();
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.addSelectionToCart();
      });

      this.selectFullButton.addEventListener('click', () => {
        this.form.querySelectorAll('[data-bundle-selection-checkbox]').forEach((input) => {
          input.checked = true;
          input.closest('.product-bundle-selection__item')?.classList.add('is-checked');
        });
        this.updateState();
      });

      document.addEventListener(
        'click',
        (event) => {
          const trigger = event.target.closest('button[type="submit"], input[type="submit"], button[name="add"]');
          const form = trigger?.form || trigger?.closest('form');

          this.interceptProductFormEvent(event, form);
        },
        true
      );

      document.addEventListener(
        'submit',
        (event) => {
          this.interceptProductFormEvent(event, event.target);
        },
        true
      );

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== this.root.dataset.sectionId) return;
          if (!this.productForm || this.root.hidden) return;

          const nextVariant = this.data.variants?.[event.data.variant?.id];
          if (nextVariant?.items?.length) {
            this.open(this.productForm, nextVariant);
          } else {
            this.close();
          }
        });
      }
    }

    interceptProductFormEvent(event, form) {
      if (!form || form.dataset.bundleSelectionBypass === 'true') return;
      if (form.closest('[data-bundle-selection]')) return;

      const variantId = form.querySelector('[name="id"]')?.value;
      const variant = this.data.variants?.[variantId];
      if (!variant?.items?.length) return;

      const sellingPlanId = getSellingPlanId(form);
      if (sellingPlanId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addSubscriptionToCart(form, sellingPlanId);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      this.open(form, variant);
    }

    addSubscriptionToCart(form, sellingPlanId) {
      const formData = new FormData(form);
      formData.set('quantity', getQuantity(form) || 1);
      formData.set('selling_plan', sellingPlanId);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status || response.errors) {
            throw new Error(response.description || response.message || (this.data.labels?.addError || 'Error adding to cart'));
          }
          window.location.href = getCheckoutUrl();
        })
        .catch((error) => {
          console.error(error);
          window.alert(error.message);
        });
    }

    open(productForm, variant) {
      this.productForm = productForm;
      this.variant = variant;
      this.quantity = getQuantity(productForm);
      this.sellingPlanId = getSellingPlanId(productForm);
      this.renderItems();
      this.root.hidden = false;
      document.body.classList.add('overflow-hidden');
      this.dialog.focus();
    }

    close() {
      this.root.hidden = true;
      document.body.classList.remove('overflow-hidden');
    }

    renderItems() {
      const itemCount = this.variant.items.reduce((total, item) => total + (Number(item.quantity) || 1), 0);
      const regularTotal = this.getRegularTotal();
      const bundlePrice = this.getBundlePrice();
      const savings = Math.max(0, regularTotal - bundlePrice);

      this.intro.innerHTML = savings > 0
        ? this.data.labels.bundleSave.replace('[amount]', formatMoney(savings, this.data.currency))
        : this.data.labels.discountNotice;

      this.itemsRoot.innerHTML = this.variant.items
        .map((item, index) => this.renderItem(item, index, itemCount, savings))
        .join('');

      this.updateState();
    }

    renderItem(item, index, itemCount, savings) {
      const itemQuantity = Number(item.quantity) || 1;
      const itemPrice = Number(item.price) || 0;
      const regularPrice = this.getItemRegularPrice(item);
      const discountPerUnit = itemCount > 0 ? Math.round(savings / itemCount) : 0;
      const bundleUnitPrice = Math.max(0, regularPrice - discountPerUnit);

      return `
        <label class="product-bundle-selection__item is-checked">
          <span class="product-bundle-selection__image">
            ${item.image ? `<img src="${item.image}" alt="${this.escapeHtml(item.title)}" loading="lazy">` : ''}
          </span>
          <span class="product-bundle-selection__name">${this.escapeHtml(item.title)}</span>
          <span class="product-bundle-selection__price" data-bundle-selection-price data-item-price="${itemPrice}" data-regular-price="${regularPrice}" data-bundle-price="${bundleUnitPrice}">
            <s>${formatMoney(regularPrice, this.data.currency)}</s>
            <span>${formatMoney(bundleUnitPrice, this.data.currency)}</span>
          </span>
          <span class="product-bundle-selection__checkbox">
            <input type="checkbox" data-bundle-selection-checkbox data-index="${index}" checked>
            <svg viewBox="0 0 12 10" aria-hidden="true" focusable="false">
              <path d="M4.2 9.4.4 5.6l1.4-1.4 2.4 2.4L10.2.6l1.4 1.4-7.4 7.4Z" fill="currentColor"/>
            </svg>
          </span>
        </label>
      `;
    }

    escapeHtml(value) {
      const element = document.createElement('span');
      element.textContent = value || '';
      return element.innerHTML;
    }

    getRegularTotal() {
      return this.variant.items.reduce((total, item) => {
        const quantity = Number(item.quantity) || 1;
        return total + this.getItemRegularPrice(item) * quantity;
      }, 0);
    }

    getItemRegularPrice(item) {
      return Math.max(Number(item.compareAtPrice) || 0, Number(item.price) || 0);
    }

    getBundlePrice() {
      const sellingPlan = this.sellingPlanId ? this.variant.sellingPlans?.[this.sellingPlanId] : null;
      return Number(sellingPlan?.price || this.variant.price || 0);
    }

    getSelectedItems() {
      return [...this.form.querySelectorAll('[data-bundle-selection-checkbox]:checked')]
        .map((input) => this.variant.items[Number(input.dataset.index)])
        .filter(Boolean);
    }

    updateState() {
      const checkboxes = [...this.form.querySelectorAll('[data-bundle-selection-checkbox]')];
      const selectedItems = this.getSelectedItems();
      const isFullBundle = selectedItems.length === checkboxes.length;
      const bundlePrice = this.getBundlePrice();
      const regularTotal = this.getRegularTotal();
      const selectedTotal = isFullBundle
        ? bundlePrice
        : selectedItems.reduce((total, item) => total + (Number(item.price) || 0) * (Number(item.quantity) || 1), 0);

      this.form.querySelectorAll('[data-bundle-selection-price]').forEach((price) => {
        const itemPrice = Number(price.dataset.itemPrice) || 0;
        const regularPrice = Number(price.dataset.regularPrice) || 0;
        const bundlePrice = Number(price.dataset.bundlePrice) || regularPrice;

        price.innerHTML = isFullBundle
          ? `<s>${formatMoney(regularPrice, this.data.currency)}</s><span>${formatMoney(bundlePrice, this.data.currency)}</span>`
          : `<span>${formatMoney(itemPrice, this.data.currency)}</span>`;
      });

      const savings = Math.max(0, regularTotal - bundlePrice);
      if (this.shippingMessage) this.shippingMessage.hidden = !isFullBundle;
      this.selectFullButton.hidden = isFullBundle;
      this.selectFullButton.textContent = savings > 0
        ? this.data.labels.selectFullSave.replace('[amount]', formatMoney(savings, this.data.currency))
        : this.data.labels.selectFull;
      this.total.innerHTML = isFullBundle && savings > 0
        ? `<s>${formatMoney(regularTotal * this.quantity, this.data.currency)}</s><span>${formatMoney(selectedTotal * this.quantity, this.data.currency)}</span>`
        : `<span>${formatMoney(selectedTotal * this.quantity, this.data.currency)}</span>`;
      this.submitButton.disabled = selectedItems.length === 0 || this.isSubmitting;
    }

    setLoading(isLoading) {
      this.isSubmitting = isLoading;
      this.submitButton.disabled = isLoading;
      this.submitButton.classList.toggle('is-loading', isLoading);
      this.submitButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
    }

    buildBundlePayload(cartUI) {
      const formData = new FormData(this.productForm);
      formData.set('quantity', this.quantity);
      if (this.sellingPlanId) {
        formData.set('selling_plan', this.sellingPlanId);
      }

      getSections(cartUI).forEach((sectionId) => {
        formData.append('sections', sectionId);
      });
      formData.append('sections_url', window.location.pathname);

      return formData;
    }

    buildSeparateItemsPayload(cartUI) {
      return {
        items: this.getSelectedItems().map((item) => ({
          id: Number(item.variantId),
          quantity: (Number(item.quantity) || 1) * this.quantity,
        })),
        sections: getSections(cartUI),
        sections_url: window.location.pathname,
      };
    }

    addSelectionToCart() {
      if (this.isSubmitting) return;

      const selectedItems = this.getSelectedItems();
      const isFullBundle = selectedItems.length === this.variant.items.length;
      const cartUI = getPreferredCartUI();
      const payload = isFullBundle ? this.buildBundlePayload(cartUI) : this.buildSeparateItemsPayload(cartUI);
      const config = fetchConfig('javascript');

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      if (payload instanceof FormData) {
        delete config.headers['Content-Type'];
        config.body = payload;
      } else {
        config.body = JSON.stringify(payload);
      }

      this.setLoading(true);

      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status || response.errors) {
            throw new Error(response.description || response.message || this.data.labels.addError);
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bundle-selection-modal',
            cartData: response,
          });

          this.close();
          window.location.href = getCheckoutUrl();
        })
        .catch((error) => {
          console.error(error);
          window.alert(error.message);
        })
        .finally(() => {
          this.setLoading(false);
        });
    }
  }

  function initBundleSelectionModals() {
    document.querySelectorAll('[data-bundle-selection]').forEach((root) => {
      if (root.dataset.bundleSelectionInitialized === 'true') return;
      root.dataset.bundleSelectionInitialized = 'true';
      new BundleSelectionModal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleSelectionModals);
  } else {
    initBundleSelectionModals();
  }
})();
